import { Center, Spinner, Portal } from '@chakra-ui/react';
import { FC } from 'react';
import { loaderSelectors } from 'store/reducers/loaderReducer/loaderSlice';
import { useAppSelector } from '../../../store/hooks/useStore';

export const Loader: FC = () => {
  const loading = useAppSelector(loaderSelectors.loading);

  if (!loading) return null;

  return (
    <Portal>
      <Center w="100%" h="100%" position="fixed" top="0" left="0" zIndex="2000">
        <Center w="72px" h="72px" borderRadius="5px" bg="rgba(0, 0, 0, 0.17)">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="#FFFFFF"
            color="brand"
            size="xl"
          />
        </Center>
      </Center>
    </Portal>
  );
};
